import { useEffect, useState } from 'react';
import { hardNavigate } from '../utils/navigation';

/**
 * Canva認証完了ページ
 *
 * このページは認証コールバックからリダイレクトされ、
 * 親ウィンドウにpostMessageを送信して認証完了を通知します。
 */
export function CanvaAuthCompletePage() {
  const [status, setStatus] = useState<'notifying' | 'closing' | 'redirecting'>('notifying');

  useEffect(() => {
    // 親ウィンドウ（opener）に認証完了を通知
    if (window.opener) {
      try {
        window.opener.postMessage({ type: 'CANVA_AUTH_SUCCESS' }, window.location.origin);
        setStatus('closing');
        // 少し待ってから閉じる
        setTimeout(() => {
          window.close();
          // 閉じれなかった場合（ブラウザの制限）は手動で閉じるよう案内
        }, 1000);
      } catch (e) {
        console.error('Failed to send postMessage:', e);
        setStatus('redirecting');
        setTimeout(() => {
          hardNavigate('/studio/image');
        }, 1500);
      }
    } else {
      // openerがない場合はスタジオにリダイレクト
      setStatus('redirecting');
      setTimeout(() => {
        hardNavigate('/studio/image');
      }, 1500);
    }
  }, []);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#1e2026',
      color: '#f5f1e6',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid rgba(var(--brand-primary-rgb) / 0.3)',
          borderTopColor: 'var(--brand-primary)',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 16px',
        }} />
        <p style={{ fontSize: '18px', marginBottom: '8px' }}>Canva認証完了</p>
        <p style={{ fontSize: '12px', color: 'rgba(245, 241, 230, 0.6)' }}>
          {status === 'closing' && 'このタブは自動的に閉じられます...'}
          {status === 'notifying' && '処理を続行しています...'}
          {status === 'redirecting' && 'スタジオに戻ります...'}
        </p>
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
}
